export const quickFacts = [
  {
    icon: "ri-user-star-line",
    label: "艺名",
    value: "松下纱荣子",
  },
  {
    icon: "ri-translate-2",
    label: "名字读法",
    value: "日文名音译，中文常见写法不止一种",
  },
  {
    icon: "ri-women-line",
    label: "性别",
    value: "女",
  },
  {
    icon: "ri-film-line",
    label: "活跃领域",
    value: "日本娱乐、写真与影像相关活动",
  },
  {
    icon: "ri-calendar-line",
    label: "活跃年代",
    value: "2010 年代起，具体年份说法不一",
  },
  {
    icon: "ri-chat-smile-2-line",
    label: "主要讨论平台",
    value: "社交平台与娱乐论坛",
  },
];

export const timelineItems = [
  {
    period: "出道阶段",
    title: "名字开始与影像作品挂钩",
    desc: "在网络资料中，松下纱荣子的名字常与若干写真及影像作品联系在一起。由于不同来源给出的出道作品与时间点并不一致，这一阶段的具体细节建议以权威渠道为准，不必轻信单一说法。",
  },
  {
    period: "人气上升期",
    title: "社交讨论量明显增加",
    desc: "随着相关作品被更多人看到，讨论范围从作品本身延伸到外形、气质与拍摄风格。娱乐论坛里开始出现以此为关键词的专门讨论帖，话题标签也逐渐固定下来。",
  },
  {
    period: "话题扩散期",
    title: "年龄与个人资料成高频搜索词",
    desc: "「年龄」「本名」「身高」等个人资料类问题被反复搜索，网络上也随之出现多个版本的说法。其中相当一部分缺少可核实的出处，因此常常引发争论。",
  },
  {
    period: "近期",
    title: "近况与社交动态重新受关注",
    desc: "近段时间，「她现在在做什么」「还会更新动态吗」这类问题热度回升，相关话题大多出现在社交平台评论区与娱乐资讯的跟帖里，整体仍以网友讨论为主。",
  },
];

export const topicItems = [
  {
    tag: "近况",
    title: "近期关注度为何再次上升",
    heat: "高",
    summary: "新一轮关注主要来自旧话题被重新翻出，加上社交平台上零散的动态被转发。讨论并没有明确的新事件支撑，更多是网友对「她现在怎么样了」的好奇集中释放。",
  },
  {
    tag: "近况",
    title: "是否还有新作品或公开活动",
    heat: "中",
    summary: "目前公开渠道没有明确的新作或活动信息。论坛里流传的一些说法缺乏出处，多数属于推测，查看时建议区分「已确认」与「听说」。",
  },
  {
    tag: "近况",
    title: "关于退圈与复出的两种说法",
    heat: "中",
    summary: "一种说法认为她已淡出并转向低调生活，另一种说法则期待其复出。两种说法都没有可靠依据，本质上是网友对同一现象的不同解读。",
  },
  {
    tag: "社交动态",
    title: "社交平台更新频率与内容风格",
    heat: "高",
    summary: "被讨论较多的动态以生活片段、日常分享类内容为主，更新节奏并不固定。网友关注的往往不是具体事件，而是照片风格与文字语气的变化。",
  },
  {
    tag: "社交动态",
    title: "ins 互动中粉丝最常问的问题",
    heat: "中",
    summary: "评论区出现频率较高的问题集中在近况、是否会回国发展以及拍摄花絮几类。由于公开回应有限，这些问题通常只能停留在留言层面。",
  },
  {
    tag: "个人资料",
    title: "年龄问题为何争议不断",
    heat: "高",
    summary: "关于年龄的说法在网络上版本较多，各方引用的依据也不统一。在没有权威确认的情况下，建议把它当作讨论话题看待，而不是当作固定事实。",
  },
  {
    tag: "个人资料",
    title: "名字的常见误写与正确读法",
    heat: "中",
    summary: "中文搜索结果里经常出现同音或形近的误写，导致信息分散在不同关键词下。整理资料时把常见误写一并列出，能减少找错人的情况。",
  },
  {
    tag: "绯闻",
    title: "与合作对象传闻的来龙去脉",
    heat: "高",
    summary: "所谓绯闻多源于同框画面与剧情设定的联想，缺少当事人确认。这类内容传播速度快，但可靠性普遍偏低，浏览时应保持谨慎。",
  },
  {
    tag: "绯闻",
    title: "网络流传的花絮说法真伪难辨",
    heat: "中",
    summary: "关于拍摄现场的花絮说法大多来自匿名转述，既没有原始出处，也难以交叉验证。它们更适合当作八卦谈资，不宜作为事实引用。",
  },
];

export const profileRows = [
  { field: "中文常用写法", value: "松下纱荣子" },
  { field: "性别", value: "女" },
  { field: "国籍", value: "日本（据公开资料）" },
  { field: "职业", value: "写真模特、影像作品出演者" },
  { field: "活跃年代", value: "2010 年代起，具体年份说法不一" },
  { field: "出生年份", value: "网络流传多个版本，缺乏可靠确认" },
  { field: "代表话题", value: "写真作品、社交平台动态、个人资料" },
  { field: "主要平台", value: "社交平台与娱乐论坛" },
];

export const socialPosts = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Warm%20minimalist%20flat%20lay%20of%20a%20coffee%20cup%20and%20open%20notebook%20on%20a%20cream%20linen%20surface%2C%20soft%20morning%20light%2C%20editorial%20lifestyle%20photography%2C%20muted%20terracotta%20and%20beige%20palette%2C%20clean%20composition&width=600&height=600&seq=saeko-social-01&orientation=squarish",
    caption: "周末的小确幸：一杯手冲，一本没读完的书。",
    likes: "2.3万",
    comments: "412",
    time: "3 天前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Delicate%20pink%20camelia%20flowers%20against%20a%20warm%20neutral%20wall%2C%20soft%20diffused%20daylight%2C%20minimal%20artistic%20still%20life%20photography%2C%20elegant%20and%20calm%20mood%2C%20muted%20color%20grade%20with%20gentle%20shadows&width=600&height=600&seq=saeko-social-02&orientation=squarish",
    caption: "路边捡到的花，随手拍了一张。",
    likes: "1.8万",
    comments: "287",
    time: "1 周前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20city%20window%20view%20at%20dusk%20with%20warm%20amber%20lights%20bokeh%2C%20abstract%20urban%20photography%2C%20soft%20grain%2C%20cinematic%20warm%20tone%2C%20calm%20and%20reflective%20atmosphere%20without%20recognizable%20faces&width=600&height=600&seq=saeko-social-03&orientation=squarish",
    caption: "收工路上，城市刚好亮灯。",
    likes: "3.1万",
    comments: "536",
    time: "2 周前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Artistic%20close%20up%20of%20silk%20fabric%20folds%20in%20champagne%20and%20rose%20tones%2C%20soft%20studio%20lighting%2C%20abstract%20texture%20photography%2C%20elegant%20editorial%20mood%2C%20smooth%20gradients%20and%20gentle%20highlights&width=600&height=600&seq=saeko-social-04&orientation=squarish",
    caption: "新拍的一组照片，风格和以前不太一样。",
    likes: "4.6万",
    comments: "902",
    time: "3 周前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20breakfast%20table%20scene%20with%20toast%20and%20fruit%20on%20a%20ceramic%20plate%2C%20warm%20morning%20sunlight%20through%20sheer%20curtains%2C%20cozy%20editorial%20food%20photography%2C%20beige%20and%20soft%20orange%20palette&width=600&height=600&seq=saeko-social-05&orientation=squarish",
    caption: "今天有好好吃早饭，值得记录一下。",
    likes: "1.2万",
    comments: "198",
    time: "1 个月前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20soft%20gradient%20background%20in%20warm%20peach%20and%20cream%20tones%20with%20subtle%20grain%2C%20minimal%20artistic%20texture%2C%20gentle%20luminous%20curves%2C%20calm%20meditative%20mood%20for%20a%20quiet%20quote%20post&width=600&height=600&seq=saeko-social-06&orientation=squarish",
    caption: "希望大家都过得安稳。谢谢一直留言的你们。",
    likes: "5.2万",
    comments: "1,240",
    time: "1 个月前",
  },
];

export const faqs = [
  {
    q: "松下纱荣子今年多大？",
    a: "网络上关于她年龄的说法并不统一，流传的版本较多，且缺少可核实的权威出处。因此本站不给出一个确定的数字，建议把相关讨论当作话题看待，而不是当作已确认的事实。",
  },
  {
    q: "她的近况到底怎么样？",
    a: "目前公开渠道没有明确的新作或活动信息，讨论主要集中在社交平台的零星动态上。整体来看，热度来自网友对她近况的好奇，而不是某个可确认的新事件。",
  },
  {
    q: "网上说的绯闻是真的吗？",
    a: "多数绯闻源自同框画面、剧情设定或匿名转述，缺少当事人确认，可靠性普遍偏低。浏览这类内容时，建议优先看是否有原始出处，再决定信不信。",
  },
  {
    q: "她有 ins 账号吗？",
    a: "相关讨论中经常提到社交平台动态，但账号的活跃程度与发布内容难以从公开渠道完全确认。本站展示的动态为相关内容示意，用于说明讨论方向，并非逐条核实。",
  },
  {
    q: "这个名字应该怎么读、怎么写？",
    a: "它是日文名的中文音译写法，搜索结果里会出现同音或形近的误写，导致信息分散。建议用完整的「松下纱荣子」进行检索，能减少找错人的情况。",
  },
  {
    q: "这一页的资料会更新吗？",
    a: "本页内容按公开信息与网络讨论的整理逻辑编排，会随着话题变化调整侧重。所有条目都标注了不确定性，方便你区分「有出处」和「听说」两类信息。",
  },
];

export const relatedTopics = [
  "松下纱荣子 近况",
  "松下纱荣子 年龄",
  "松下纱荣子 个人资料",
  "松下纱荣子 绯闻",
  "松下纱荣子 ins",
  "松下纱荣子 写真",
  "松下纱荣子 出道",
  "松下纱荣子 讨论",
];